import { trackEvent } from 'dibs-tracking';

type Event = Parameters<typeof trackEvent>[1];

export const trackMainCarouselClick = (
    {
        activeSlide,
        totalSlides,
    }: {
        activeSlide: number;
        totalSlides: number;
    },
    event: Event
): void => {
    trackEvent(
        {
            category: 'product',
            action: 'primary image click',
            label: `${activeSlide}/${totalSlides}`,
        },
        event
    );
};

export const trackViewRoomDisplayed = ({
    activeSlide,
    totalSlides,
}: {
    activeSlide: number;
    totalSlides: number;
}): void =>
    trackEvent({
        category: 'product',
        action: 'view in room displayed',
        label: `${activeSlide}/${totalSlides}`,
    });

export const trackArrowClick = ({
    slideType,
    activeSlide,
    totalSlides,
    arrowDirection,
}: {
    slideType: 'photo' | 'viewInRoom' | 'video' | 'requestMore';
    activeSlide: number;
    totalSlides: number;
    arrowDirection: 'next' | 'previous';
}): void => {
    trackEvent({
        category: 'product',
        action: `pdp image carousel ${arrowDirection} button`,
        label:
            slideType === 'requestMore'
                ? 'contact dealer - pdp image carousel'
                : `${activeSlide}/${totalSlides}`,
        isInteractiveEvent: true,
    });
    return;
};
